import { Component } from "react";

/**
 * BlockErrorBoundary — catches render/runtime crashes inside a single
 * block so a bad embed (e.g. Spotify iframe throwing "RangeError:
 * Incorrect locale information provided") does not blow up the whole
 * live preview or the public bio hub.
 *
 * Renders a compact fallback with a Retry button (which resets the
 * boundary so a fresh render can succeed after the transient error).
 */
export default class BlockErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.warn("[BlockErrorBoundary] caught", this.props.label || "", error?.message, info?.componentStack);
  }
  reset = () => this.setState({ hasError: false, error: null });
  render() {
    if (this.state.hasError) {
      return (
        <div
          className="ah-block text-xs ah-muted flex items-center justify-between gap-2"
          data-testid={this.props.testid || "block-error-fallback"}
          role="alert"
        >
          <span>
            {this.props.fallbackLabel || "This block can't render right now."}
          </span>
          <button
            type="button"
            onClick={this.reset}
            className="border-2 border-current px-2 py-1 text-[10px] font-bold uppercase tracking-wider"
            data-testid={`${this.props.testid || "block-error"}-retry`}
          >
            Retry
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
